module.exports = __webpack_public_path__ + "static/img/gxg1.da69da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg1.png
// module id = xwhT
// module chunks = 2